import styled, { css } from "styled-components";

export const MProductTagWrap = styled.section`
	width: 100%;
	height: 3rem;
	margin-top: 0.5rem;
	box-sizing: border-box;
	background: #fff;
`;

export const MProductTagBox = styled("ul").withConfig({
	shouldForwardProp: (prop) => !["scrollTop", "isFixed"].includes(prop),
})<{ isFixed: boolean; scrollTop: number }>`
	box-sizing: border-box;
	width: inherit;
	height: inherit;
	padding: 0.5625rem 0.75rem;
	display: flex;
	white-space: nowrap;
	overflow-x: scroll;
	background: #fff;
	list-style: none;

	${(props: { isFixed: boolean; scrollTop: number }) => {
		if (props.isFixed) {
			return css`
				position: fixed;
				left: 0;
				top: ${props.scrollTop}px;
				width: 100%;
				z-index: 30;
			`;
		}
		return "";
	}}
	&::-webkit-scrollbar {
		display: none;
		width: 0;
		height: 0;
	}
`;

export const MProductTagtab = styled.li`
	box-sizing: border-box;
	font-size: 0.875rem;
	padding: 0.4375rem 0.5rem;
	border-radius: 2px;
	margin-right: 0.25rem;
	line-height: 1rem;
	font-weight: 500;
`;
